module.exports = __webpack_public_path__ + "assets/img/6415dc47fa726d0d5a36fc6898e60bf3.png";